// src/pages/BulkListingGenerator/components/bulkColumnMappings.js
// Centralized column name constants and pure helper functions shared across
// BulkFormHelper, BulkFormHelperNew, and UploadScreen.

// ── SKU / identity columns ──────────────────────────────────────────────────
export const SKU_COLUMNS = [
    'SKU', 'SKU ID', 'sku', 'sku_id', 'Product SKU', 'product_sku',
    'Model Number/SKU', 'Model Number', 'model_number',
    'Model/SKU', 'MODEL NUMBER', 'model number', 'ModelNumber'
];

export const IS_PARENT_COLUMNS = ['isParent', 'Is Parent', 'is_parent', 'IsParent', 'Parent'];

export const BRAND_COLUMNS = ['Brand', 'Brand Name', 'brand_name', 'brand', 'BRAND NAME'];
export const CATEGORY_COLUMNS = ['Category', 'category', 'CATEGORY'];
export const SUB_CATEGORY_COLUMNS = ['Sub Category', 'sub_category', 'SubCategory', 'subcategory', 'SUB CATEGORY'];
export const PRODUCT_TYPE_COLUMNS = ['Product Type', 'product_type', 'ProductType', 'producttype', 'PRODUCT TYPE'];
export const TITLE_COLUMNS = ['Title', 'title', 'TITLE', 'Item Name', 'item_name'];
export const PARENT_SKU_COLUMNS = ['Parent SKU', 'parent_sku', 'ParentSKU', 'Parent', 'Parent SKU ID', 'parent_sku_id'];

// ── Product detail columns ──────────────────────────────────────────────────
export const COLOR_COLUMNS = ['Color', 'color', 'COLOR'];
export const MATERIAL_COLUMNS = ['Material', 'material', 'MATERIAL'];
export const SIZE_COLUMNS = ['Size/Dimensions', 'Size', 'size', 'SIZE'];
export const EAN_COLUMNS = ['EAN', 'ean', 'EAN Number', 'ean_number', 'EAN_NUMBER'];
export const KEYWORDS_COLUMNS = ['Additional Keywords (comma-separated)', 'Keywords', 'keywords', 'KEYWORDS'];
export const BANNED_KEYWORDS_COLUMNS = ['Banned Keywords', 'banned_keywords', 'BannedKeywords', 'BANNED KEYWORDS', 'Words to Avoid'];
export const DESCRIPTION_COLUMNS = ['Product Description', 'Description', 'description', 'Brief Description', 'brief_description', 'DESCRIPTION'];

// ── Bullet / feature columns (existing mode) ───────────────────────────────
export const BULLET_1_COLUMNS = ['Bullet Point 1', 'Bullet 1', 'bullet_1', 'Feature 1', 'feature_1', 'BULLET 1'];
export const BULLET_2_COLUMNS = ['Bullet Point 2', 'Bullet 2', 'bullet_2', 'Feature 2', 'feature_2', 'BULLET 2'];
export const BULLET_3_COLUMNS = ['Bullet Point 3', 'Bullet 3', 'bullet_3', 'Feature 3', 'feature_3', 'BULLET 3'];
export const BULLET_4_COLUMNS = ['Bullet Point 4', 'Bullet 4', 'bullet_4', 'Feature 4', 'feature_4', 'BULLET 4'];
export const BULLET_5_COLUMNS = ['Bullet Point 5', 'Bullet 5', 'bullet_5', 'Feature 5', 'feature_5', 'BULLET 5'];

// ── Core product detail columns (new mode – includes bullet fallbacks) ──────
export const CORE_DETAIL_1_COLUMNS = ['Core Product Details 1', ...BULLET_1_COLUMNS];
export const CORE_DETAIL_2_COLUMNS = ['Core Product Details 2', ...BULLET_2_COLUMNS];
export const CORE_DETAIL_3_COLUMNS = ['Core Product Details 3', ...BULLET_3_COLUMNS];
export const CORE_DETAIL_4_COLUMNS = ['Core Product Details 4', ...BULLET_4_COLUMNS];
export const CORE_DETAIL_5_COLUMNS = ['Core Product Details 5', ...BULLET_5_COLUMNS];

// ── Core product details ONLY (avoid bullet fallback; used in existing-mode Key Features) ──
export const CORE_DETAIL_ONLY_1_COLUMNS = ['Core Product Details 1', 'core_product_details_1', 'CoreProductDetails1'];
export const CORE_DETAIL_ONLY_2_COLUMNS = ['Core Product Details 2', 'core_product_details_2', 'CoreProductDetails2'];
export const CORE_DETAIL_ONLY_3_COLUMNS = ['Core Product Details 3', 'core_product_details_3', 'CoreProductDetails3'];
export const CORE_DETAIL_ONLY_4_COLUMNS = ['Core Product Details 4', 'core_product_details_4', 'CoreProductDetails4'];
export const CORE_DETAIL_ONLY_5_COLUMNS = ['Core Product Details 5', 'core_product_details_5', 'CoreProductDetails5'];

// ── Application columns (new mode only) ─────────────────────────────────────
export const APPLICATION_1_COLUMNS = ['Application 1 (Give a use case statement)', 'Application 1', 'application_1', 'Application1'];
export const APPLICATION_2_COLUMNS = ['Application 2 (Give a use case statement)', 'Application 2', 'application_2', 'Application2'];

// ── Parent-child attribute columns (new mode only) ──────────────────────────
export const PARENT_CHILD_ATTR_1_COLUMNS = ['Parent Child Attribute 1', 'parent_child_attribute_1', 'ParentChildAttribute1'];
export const PARENT_CHILD_ATTR_1_VALUE_COLUMNS = ['Parent Child Attribute 1 Value', 'parent_child_attribute_1_value', 'ParentChildAttribute1Value'];
export const PARENT_CHILD_ATTR_2_COLUMNS = ['Parent Child Attribute 2', 'parent_child_attribute_2', 'ParentChildAttribute2'];
export const PARENT_CHILD_ATTR_2_VALUE_COLUMNS = ['Parent Child Attribute 2 Value', 'parent_child_attribute_2_value', 'ParentChildAttribute2Value'];
export const PARENT_CHILD_ATTR_3_COLUMNS = ['Parent Child Attribute 3', 'parent_child_attribute_3', 'ParentChildAttribute3'];
export const PARENT_CHILD_ATTR_3_VALUE_COLUMNS = ['Parent Child Attribute 3 Value', 'parent_child_attribute_3_value', 'ParentChildAttribute3Value'];

// ── Dimension columns (superset – supports both modes) ─────────────────────
export const LENGTH_COLUMNS = ['Length', 'length', 'LENGTH', 'Dimension Length', 'Dimensions Length', 'dimension_length'];
export const BREADTH_COLUMNS = ['Breadth', 'breadth', 'BREADTH', 'Width', 'width', 'WIDTH', 'Dimension Breadth', 'Dimension Width', 'Dimensions Breadth', 'dimension_breadth'];
export const HEIGHT_COLUMNS = ['Depth', 'depth', 'DEPTH', 'Height', 'height', 'HEIGHT', 'Dimension Height', 'Dimension Depth', 'Dimensions Height', 'dimension_height', 'dimension_depth'];
export const UNITS_COLUMNS = ['Unit', 'unit', 'UNIT', 'Units', 'units', 'Dimension Units', 'Dimensions Units'];

// ── Pure helper functions ───────────────────────────────────────────────────

/**
 * Find the first non-empty value in `row` that matches one of `possibleNames`
 * (case-insensitive fallback).
 */
export const findColumnValue = (row, possibleNames) => {
    if (!row) return '';
    for (const name of possibleNames) {
        if (row[name] !== undefined && row[name] !== null && row[name] !== '') {
            return String(row[name]).trim();
        }
        const lowerName = name.toLowerCase();
        for (const key in row) {
            if (key.toLowerCase() === lowerName && row[key] !== undefined && row[key] !== null && row[key] !== '') {
                return String(row[key]).trim();
            }
        }
    }
    return '';
};

/**
 * Derive a SKU from Title when SKU column is empty.
 * Creates a URL-safe slug from the first 40 chars of the title, plus row index for uniqueness.
 */
export const deriveSkuFromTitle = (title, rowIndex = 0) => {
    if (!title || typeof title !== 'string') return `product_${rowIndex + 1}`;
    const slug = String(title)
        .trim()
        .slice(0, 50)
        .replace(/[^a-zA-Z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .toLowerCase()
        .replace(/^-|-$/g, '');
    return slug || `product_${rowIndex + 1}`;
};

/**
 * Find a row in `rows` whose SKU column matches `sku`.
 */
export const findExcelRow = (rows, sku) => {
    if (!rows || !sku) return null;
    return rows.find(r => {
        const rowSku = findColumnValue(r, SKU_COLUMNS);
        const rowTitle = findColumnValue(r, TITLE_COLUMNS);
        const derived = !rowSku ? deriveSkuFromTitle(rowTitle, rows.indexOf(r)) : rowSku;
        return rowSku === sku || derived === sku;
    }) || null;
};

/**
 * Fuzzy-match a folder name in `skuImages` to a given `sku`.
 * Returns the matched folder key or null.
 */
export const matchSkuFolder = (skuImages, sku) => {
    if (!skuImages || !sku) return null;
    const skuLower = sku.toLowerCase();
    const folders = Object.keys(skuImages);
    // 1. Exact match
    const exact = folders.find(f => f.toLowerCase() === skuLower);
    if (exact) return exact;
    // 2. Folder starts with SKU (e.g. folder "SKU123_images" matches SKU "SKU123")
    const prefixed = folders.find(f => f.toLowerCase().startsWith(skuLower));
    if (prefixed) return prefixed;
    // 3. SKU starts with folder (e.g. SKU "SKU123-variant" matches folder "SKU123")
    const reverse = folders.find(f => skuLower.startsWith(f.toLowerCase()));
    if (reverse) return reverse;
    return null;
};

/**
 * Build a dimensionData object from an Excel row.
 * Uses the superset of column names (supports Depth/Unit for both modes).
 */
export const getDimensionDataFromRow = (row) => {
    if (!row) return null;
    const length = findColumnValue(row, LENGTH_COLUMNS);
    const breadth = findColumnValue(row, BREADTH_COLUMNS);
    const height = findColumnValue(row, HEIGHT_COLUMNS);
    const units = findColumnValue(row, UNITS_COLUMNS) || 'cm';
    if (!length && !breadth && !height) return null;
    return {
        length: length || '',
        breadth: breadth || '',
        height: height || '',
        units: units || 'cm',
        isComplete: !!(length && breadth),
        dimensionImage: null
    };
};
